
import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HistoryComponent } from '@lib/components/history/history';
import { FileMetadata } from '@lib/models/generated/graphql';
import { AuthService } from '@lib/services/auth-service.service';
import { HistoryDisplayedRecord, HistoryService } from '@lib/services/historyService';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoadingModule } from 'omnium-ui/loading';
import { OuiSnackbarModule, OuiSnackbarService } from 'omnium-ui/snackbar';

@Component({
    selector: 'lib-file-historique-dialog',
    imports: [
    OuiDialogModule,
    OuiButtonModule,
    OuiIconModule,
    OuiSnackbarModule,
    OuiLoadingModule,
    HistoryComponent
],
    templateUrl: './file-historique-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./file-historique-dialog.component.scss']
})
export class FileHistoriqueDialogComponent {
  historyDisplayedEntries: HistoryDisplayedRecord[] = [];

  isloading: boolean = true;
  isBackoffice: boolean = false;

  @Output() documentOpen = new EventEmitter<FileMetadata>();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { operationId: number; fichierOperationId: number },
    private dialogRef: MatDialogRef<FileHistoriqueDialogComponent>,
    private historyService: HistoryService,
    private authService: AuthService,
    private snackbarService: OuiSnackbarService
  ) {}

  ngOnInit() {
    this.isBackoffice = this.authService.isBackOffice();
    this.getOperationHistory();
  }

  private async getOperationHistory() {
    try {
      this.historyDisplayedEntries = await this.historyService.fetchHistory(
        this.data.operationId,
        this.data.fichierOperationId,
        !this.authService.isBackOffice()
      );
      this.isloading = false;
    } catch (error) {
      this.snackbarService.open("Une erreur est survenue durant la récupération de l'historique", 'error');
      this.dialogRef.close();
    }
  }
}
